import "./Home.css";
import SignSearchView from "../SignSearchView/SignSearchView";
import CookiesModal from "../CookiesModal/CookiesModal";

export default function Home() {
    return (
        <div className="component-container">
            <SignSearchView />
            <CookiesModal/>
        </div>
    );
}
